import { store } from '@atredux/store'
import { CrossFrameUtils, PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { getSeawardIFrame } from '@atredux/selectors/iframeSelector'
import {
    warmup,
    getAlphanumeric,
    getConfirmation,getCustomDataType,
    getDate,
    getNumber,
    getPositiveInteger,
} from '@services/voice/PeppermintService'

/**
 * Cross frame listener for peppermint. It call peppermint listener registered in Old seaward.
 *
 * Listens for peppermint requests and forwards them to the peppermintService.
 * Returns a promise from the peppermintService.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'getAlphanumeric', 'getConfirmation', 'getDate', 'getPositiveInteger', 'getCustomDataType'
 *          parameters: {object} - object containing the parameters for the specific action
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */

/**
 * Listens for peppermint requests and forwards them to the peppermintService.
 * Returns a promise from the peppermintService.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'getAlphanumeric', 'getConfirmation', 'getDate', 'getPositiveInteger', 'getCustomDataType'
 *          parameters: {object} - object containing the parameters for the specific action
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function peppermintListener (message: any) {
    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {
    case 'warmup':
        return warmup()
    case 'getAlphanumeric':
        return getAlphanumeric(params)
    case 'getConfirmation':
        return getConfirmation(params)
    case 'getCustomDataType':
        return getCustomDataType(params)
    case 'getDate':
        return getDate(params)
    case 'getNumber':
        return getNumber(params)
    case 'getPositiveInteger':
        return getPositiveInteger(params)
    }
    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
